__turbopack_context__.v({
  "className": "jetbrains_mono_aba0f273-module__Fhn67W__className",
});
